import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { loadFileByUrl } from '../actions';
import { responseLogWithNotification } from '../../../utils/utils';

const { renderAsync } = require('docx-preview');

export default function DocxViewer({ src }) {
  const containerRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!src || !containerRef.current) return;
    containerRef.current.innerHTML = '';
    dispatch(loadFileByUrl(src))
      .then(data => {
        renderAsync(data, containerRef.current, undefined, {
          className: 'docx',
          inWrapper: true,
          ignoreWidth: false,
          ignoreHeight: false,
          breakPages: true,
        }).catch(responseLogWithNotification);
      })
      .catch(responseLogWithNotification);
  }, [src]);

  return <div ref={containerRef} />;
}
